<template>
  <div>
    <conditions-for-participation-counseling />
    <privacy />
  </div>
</template>

<script>
import Privacy from '@/components/Privacy.vue'
import ConditionsForParticipationCounseling from '@/components/ConditionsForParticipationCounseling.vue'
export default {
  components: { Privacy, ConditionsForParticipationCounseling },
}
</script>
